<template>
  <v-container class="px-8">
    <div class="py-3 pl-2 flex-grow-0 flex-shrink-0">
      <div class="text-h4 font-weight-medium">
        {{ $t(`navbar.menu.${type == "admins" ? "admins" : "travelers"}`) }}
      </div>
    </div>

    <v-card>
      <v-card-text>
        <div class="d-flex justify-space-between mx-4">
          <!-- <div class="text-right"> -->
          <v-btn class="mr-4" outlined color="primary" dark @click="showSelect = !showSelect">
            {{ $t("itinerary.itinerary.bulkActions") }}
          </v-btn>

          <v-menu offset-y v-if="$props.type != 'admins'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                Invite
                <!-- <v-icon>mdi-email</v-icon> -->
              </v-btn>
            </template>
            <v-list>
              <QRCodeDialog />
              <InviteTraveler :admin="type == 'admins'" />
            </v-list>
          </v-menu>
          <InviteTraveler v-else :admin="type == 'admins'" />
        </div>
        <div class="d-flex mx-4 mt-2" v-if="selected.length > 0">
          <v-btn small text color="primary" @click="bulkSendEmail"> Send Email </v-btn>
          <v-btn small text color="primary" @click="bulkSwitchAdmin">
            {{
              type == "admins" ? $t("users.Travelers.removeAdmin") : $t("users.Travelers.makeAdmin")
            }}
          </v-btn>
        </div>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="tableUsers"
          :items-per-page="15"
          :show-select="showSelect"
        >
          <template v-slot:[`item.profile_pic`]="{ item }">
            <v-avatar v-if="item.profile_pic != 'no_image'" size="40">
              <v-img :src="imageUrls[item.id] || require('@/assets/profile_pic_empty.png')"></v-img>
            </v-avatar>
          </template>

          <template v-slot:[`item.location_enabled`]="{ item }">
            <p v-if="item.location_enabled == undefined || item.location_sharing === undefined">
              {{ $t("users.Travelers.notAvailable") }}
            </p>
            <v-chip
              v-else-if="!item.location_enabled"
              class="mx-2"
              color="primary"
              text-color="white"
            >
              <v-icon left>mdi-map-marker-off</v-icon>
              {{ $t("common.disabled") }}
            </v-chip>
            <v-chip
              v-else-if="item.location_enabled"
              class="mx-2"
              color="primary"
              text-color="white"
            >
              <v-icon left>mdi-map-marker</v-icon>
              {{ $t(`location_sharing.${item.location_sharing}`) }}
            </v-chip>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <div class="text-center">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">mdi-dots-horizontal</v-icon>
                </template>
                <v-list>
                  <v-list-item v-if="canSwitchAdmin(item)" @click="switchAdmin(item)">
                    <v-list-item-title>
                      {{
                        type == "admins"
                          ? $t("users.Travelers.removeAdmin")
                          : $t("users.Travelers.makeAdmin")
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status_key != 'removed'" @click="sendEmail(item.email)">
                    <v-list-item-title>{{ $t("common.email") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.status_key == 'invited'"
                    @click="removeInvite(item.email)"
                  >
                    <v-list-item-title>{{ $t("users.Travelers.deleteInvite") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status_key == 'request'" @click="acceptUser(item.id)">
                    <v-list-item-title>{{ $t("users.Travelers.acceptInvite") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="canSwitchAdmin(item)" @click="deleteUserDialog(item)">
                    <v-list-item-title>{{ $t("users.Travelers.deleteUser") }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>

          <template v-slot:no-data>
            <h2>{{ $t("users.Travelers.noTravelers") }}</h2>
          </template>
        </v-data-table>
        <v-dialog v-model="deleteDialog" max-width="290">
          <v-card>
            <v-card-title class="headline">{{ $t("users.Travelers.deleteUserQ") }}</v-card-title>

            <v-card-text v-if="deleteDialog">
              <p v-if="deleteUserError">Error: {{ deleteUserError }}</p>
              <p v-else-if="!deletingFinished">
                {{
                  $t("users.Travelers.fromTheGroup", {
                    name: deleteUserItem.name,
                  })
                }}
              </p>
              <p v-else>{{ $t("users.Travelers.userDeletedSuccess") }}</p>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="(deletingFinished || deleteUserError != undefined) && !isDeletingUser"
                color="primary darken-1"
                text
                @click="closeDialog"
                >{{ $t("common.close") }}</v-btn
              >
              <v-btn v-else color="primary darken-1" text @click="closeDialog">{{
                $t("common.cancel")
              }}</v-btn>

              <v-btn
                v-if="!deletingFinished && deleteUserError == undefined"
                :loading="isDeletingUser"
                color="error darken-1"
                @click="deleteUser()"
                >{{ $t("common.delete") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
// import { mapGetters } from "vuex";
// import UserCard from "./UserCard";
import firestore from "@/firebase/firestore";
import functions from "@/firebase/functions";
import _ from "lodash";
import InviteTraveler from "./InviteTraveler";
import QRCodeDialog from "./QRCodeDialog";

export default {
  name: "Travelers",
  props: ["type"],
  components: {
    InviteTraveler,
    QRCodeDialog,
    // UserCard
  },
  data() {
    return {
      deleteUserItem: null,
      deleteDialog: false,
      deleteUserError: null,
      isDeletingUser: false,
      deletingFinished: false,
      showSelect: false,
      selected: [],
      snackbar: false,
      snackText: "",
      headers: [
        {
          text: "",
          value: "profile_pic",
          sortable: false,
          width: "50px",
        },
        {
          text: this.$i18n.t("common.name"),
          align: "left",
          value: "name",
        },
        {
          text: this.$i18n.t("common.email"),
          value: "email",
          sortable: false,
        },
        {
          text: this.$i18n.t("common.location"),
          value: "location_enabled",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("common.status"),
          value: "status",
          sortable: true,
        },
        {
          text: this.$i18n.t("common.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  methods: {
    closeDialog() {
      this.deleteDialog = false;
      this.deleteUserItem = null;
      this.deleteUserError = null;
      this.isDeletingUser = false;
      this.deletingFinished = false;
    },
    deleteUserDialog(user) {
      this.deleteUserItem = user;
      this.deleteDialog = true;
      this.deleteUserError = null;
    },
    async acceptUser(userId) {
      const tripId = this.$store.getters.currentTripId;
      await functions.acceptUser({ tripId, userId });
      console.log("accept success");
      this.snackText = this.$t("common.success");
      this.snackbar = true;
    },
    deleteUser() {
      this.isDeletingUser = true;

      const tripId = this.$store.getters.currentTripId;
      console.log(`deletting user ${this.deleteUserItem.id} in trip: ${tripId}`);

      functions
        .removeUserFromTrip({ tripId, user: this.deleteUserItem.id })
        .then((result) => {
          console.log(result);
          this.isDeletingUser = false;
          this.deletingFinished = true;
        })
        .catch((error) => {
          const { message } = error;
          console.log(message);
          this.deleteUserError = message;
          this.isDeletingUser = false;
        });
    },
    removeInvite(email) {
      const { id: tripId } = this.$store.state.trip.trip;
      const invites = this.$store.state.trip.trip.invites.filter(
        (invite) => invite.email !== email,
      );
      firestore.updateTrip(tripId, { invites });
    },
    bulkSwitchAdmin() {
      const { trip } = this.$store.state.trip;
      const users = this.selected
        .filter((user) => this.canSwitchAdmin(user))
        .map((user) => user.id);
      console.log(users);
      const update = {};
      users.forEach((id) => {
        update[`user_ids.${id}`] = this.$props.type !== "admins";
      });
      firestore.updateTrip(trip.id, update);
      this.selected = [];
      this.showSelect = false;
    },
    bulkSendEmail() {
      const emails = this.selected.map((user) => user.email);
      window.location.href = `mailto:${emails.join()}`;
      this.selected = [];
      this.showSelect = false;
    },
    sendEmail(email) {
      window.location.href = `mailto:${email}`;
      console.log(`this should send an email to ${email}`);
    },
    switchAdmin(user) {
      const { trip } = this.$store.state.trip;
      const userIds = _.clone(trip.user_ids);
      userIds[user.id] = this.$props.type !== "admins";
      firestore.updateTrip(trip.id, { user_ids: userIds });
    },
    canSwitchAdmin(user) {
      return this.currentUserId !== user.id && user.status === this.$t("user_status.joined");
      // this.$props.type == "admins" &&
    },
    migrateInvites(invites) {
      // Check if invites is an object (map) and not an array
      if (!Array.isArray(invites) && typeof invites === "object" && invites !== null) {
        return Object.keys(invites).map((email) => ({ email, asAdmin: invites[email] }));
      }

      // If invites is already an array, return it as is
      return invites;
    },
  },
  computed: {
    // ...mapGetters(["nonAdmins", "admins"]),
    tableType() {
      return this.$props.type === "admins" ? "admins" : "nonAdmins";
    },

    invites() {
      const isAdmins = this.tableType === "admins";

      const { invites } = this.$store.state.trip.trip;
      const inviteEmails = [];
      this.migrateInvites(invites ?? []).forEach((invite) => {
        if (invite.asAdmin === isAdmins) {
          const name = invite.email
            .split("@")[0] // Get the part before the @
            .replace(/[0-9]/g, "") // Remove all numbers
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/,/g, " ") // Replace commas with spaces
            .split(" ") // Split the name into words
            .filter((word) => word.length >= 3) // Filter out words with less than 3 characters
            // eslint-disable-next-line max-len
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" "); // Join the words back into a single string
          inviteEmails.push({
            profile_pic: "no_image",
            name,
            status: this.$t("user_status.invited"),
            status_key: "invited",
            email: invite.email,
          });
        }
      });
      return inviteEmails;
    },
    removedUsers() {
      if (this.tableType === "admins") {
        return [];
      }
      const { users } = this.$store.state;
      const userIds = this.$store.state.trip.trip.removed_users;
      const removedUsers = [];
      Object.keys(userIds || {}).forEach((key) => {
        const user = users[key];
        console.log(user);
        if (user) {
          removedUsers.push({
            ...user,
            status: this.$t("user_status.removed"),
            status_key: "removed",
          });
        }
      });
      return removedUsers;
    },
    userRequests() {
      console.log("getting userRequests");
      if (this.tableType === "admins") {
        return [];
      }
      const { users } = this.$store.state;
      const userIds = Object.keys(this.$store.state.trip.trip.user_requests || {});
      console.log("requests userss", userIds);
      const requests = [];
      userIds.forEach((key) => {
        const user = users[key];
        console.log(user);
        if (user) {
          requests.push({
            ...user,
            status: this.$t("user_status.waitlist"),
            status_key: "request",
          });
        }
      });
      return requests;
    },
    tableUsers() {
      const users = this.$store.getters[this.tableType]
        .map((user) => ({ ...user, status: this.$t("user_status.joined") }))
        .sort((a, b) => ((a.name || "").toLowerCase() > (b.name || "").toLowerCase() ? 1 : -1));

      return [...this.invites, ...users, ...this.removedUsers, ...this.userRequests];
    },
    imageUrls() {
      return this.$store.state.imageUrls;
    },
    currentUserId() {
      return this.$store.state.firUser.uid;
    },
  },
  filters: {
    capitalize: (value) => {
      if (!value) return "";
      const val = value.toString();
      return val.charAt(0).toUpperCase() + val.slice(1);
    },
  },
};
</script>
